module.exports = __webpack_public_path__ + "img/comment-icon.53c4aefe.svg";